const categories = [
    {
      title: "Základy virtualizace",
      questions: [
        {
          value: 100,
          question: "???",
          options: [
            "Zrychlí internetové připojení",
            "Umožní běh více OS na jednom stroji",
            "Odstraní potřebu RAM",
            "Automaticky aktualizuje BIOS"
          ],
          answer: "Umožní běh více OS na jednom stroji"
        },
        {
          value: 200,
          question: "???",
          options: [
            "Firewall",
            "RAID controller",
            "Hypervisor",
            "Load balancer"
          ],
          answer: "Hypervisor"
        },
        {
          value: 300,
          question: "???",
          options: [
            "Vždy potřebuje Windows",
            "Běží jen v cloudu",
            "Nemá hostitelský operační systém",
            "Spouští se z VM konzole"
          ],
          answer: "Nemá hostitelský operační systém"
        },
        {
          value: 400,
          question: "???",
          options: [
            "Typ 1 má lepší správu sítě",
            "Typ 1 běží bez hostitelského OS",
            "Typ 2 používá VM z image souboru",
            "Typ 1 je vhodný hlavně pro testování"
          ],
          answer: "Typ 1 běží bez hostitelského OS"
        },
        {
          value: 500,
          question: "???",
          options: [
            "Přetížení fyzické RAM hostitele",
            "Nesoulad mezi verzemi VM",
            "Nekontrolovaný růst počtu VM bez účelu",
            "Nestabilita sítě kvůli VM migraci"
          ],
          answer: "Nekontrolovaný růst počtu VM bez účelu"
        },
      ],
    },
    {
      title: "Virtualizace desktopů",
      questions: [
        {
          value: 100,
          question: "???",
          options: [
            "Pro testování myši",
            "Pro vzdálený přístup na virtuální desktop",
            "Pro aktualizaci BIOSu",
            "Pro zálohu e-mailů"
          ],
          answer: "Pro vzdálený přístup na virtuální desktop"
        },
        {
          value: 200,
          question: "???",
          options: [
            "Služba sledování sítě",
            "Aplikační firewall",
            "Desktop jako služba z cloudu",
            "Typ zálohovací jednotky"
          ],
          answer: "Desktop jako služba z cloudu"
        },
        {
          value: 300,
          question: "???",
          options: [
            "VDI je placený, DaaS zdarma",
            "DaaS běží lokálně",
            "DaaS poskytuje desktop z cloudu, VDI bývá on-premise",
            "VDI nemůže používat Windows"
          ],
          answer: "DaaS poskytuje desktop z cloudu, VDI bývá on-premise"
        },
        {
          value: 400,
          question: "???",
          options: [
            "Windows Remote Desktop Gateway",
            "VMware ESXi bez Horizon",
            "Citrix Virtual Apps and Desktops",
            "Hyper-V s lokální správou"
          ],
          answer: "Citrix Virtual Apps and Desktops"
        },
        {
          value: 500,
          question: "???",
          options: [
            "Počet aktivních domén",
            "Latence a IOPS úložiště",
            "Rozlišení klientských monitorů",
            "Rychlost přihlášení do domény"
          ],
          answer: "Latence a IOPS úložiště"
        },
      ],
    },
    {
      title: "Virtualizace úložišť",
      questions: [
        {
          value: 100,
          question: "???",
          options: [
            "Počítač bez pevného disku",
            "Síťové úložiště pro soubory",
            "Typ bezdrátového routeru",
            "Režim chlazení serveru"
          ],
          answer: "Síťové úložiště pro soubory"
        },
        {
          value: 200,
          question: "???",
          options: [
            "Vyšší teplota disků",
            "Efektivnější správa diskového prostoru",
            "Potřeba více napájecích zdrojů",
            "Snazší propojení s tiskárnami"
          ],
          answer: "Efektivnější správa diskového prostoru"
        },
        {
          value: 300,
          question: "???",
          options: [
            "NAS je blokové, SAN souborové",
            "SAN poskytuje blokový přístup, NAS souborový",
            "NAS má vždy větší kapacitu",
            "SAN nelze připojit přes síť"
          ],
          answer: "SAN poskytuje blokový přístup, NAS souborový"
        },
        {
          value: 400,
          question: "???",
          options: [
            "RAID s kontrolérem",
            "Ceph",
            "Fibre Channel Zoning",
            "ISCSI target software"
          ],
          answer: "Ceph"
        },
        {
          value: 500,
          question: "???",
          options: [
            "Velikost clusteru",
            "Typ souborového systému",
            "Latence I/O operací",
            "Celkový počet VM"
          ],
          answer: "Latence I/O operací"
        },
      ],
    },
    {
      title: "Pokročilé koncepty a trendy",
      questions: [
        {
          value: 100,
          question: "???",
          options: [
            "Přenos dat přes USB",
            "Služby a úložiště dostupné přes internet",
            "Software pro správu disků",
            "Typ Wi-Fi zabezpečení"
          ],
          answer: "Služby a úložiště dostupné přes internet"
        },
        {
          value: 200,
          question: "???",
          options: [
            "Fyzická schránka na server",
            "Místo pro optický kabel",
            "Izolované prostředí pro běh aplikace",
            "Redundantní diskový oddíl"
          ],
          answer: "Izolované prostředí pro běh aplikace"
        },
        {
          value: 300,
          question: "???",
          options: [
            "VM jsou lehčí než kontejnery",
            "Kontejnery sdílí OS jádro, VM mají vlastní",
            "Kontejnery běží jen na Windows",
            "VM se dají spouštět na mobilech"
          ],
          answer: "Kontejnery sdílí OS jádro, VM mají vlastní"
        },
        {
          value: 400,
          question: "???",
          options: [
            "Chybějící licence Office",
            "Síťová latence a datový přenos",
            "Nutnost SSD ve všech klientech",
            "Ovladače pro staré periferie"
          ],
          answer: "Síťová latence a datový přenos"
        },
        {
          value: 500,
          question: "???",
          options: [
            "Kubernetes + Git",
            "Terraform + Ansible",
            "Puppet + Excel",
            "Synology + rsync"
          ],
          answer: "Terraform + Ansible"
        },
      ],
    },
  ];
  
  export default categories;
  